<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget mb-30">
                    <h3>Bize Ulaşın</h3>
                    <ul class="contact-us-link">
                        <li>
                            <i class='bx bx-map'></i>
                            <a href="https://maps.app.goo.gl/YjAdF55S7YdcwE3z8" target="_blank">Rue Brichaut 5 1030,
                                Brussels, Belgium</a>
                        </li>
                        <!-- <li>
                            <i class='bx bx-phone-call'></i>
                            <a href="tel:+11234567890">+1 (123) 456 7890</a>
                        </li> -->
                        <li>
                            <i class='bx bx-envelope'></i>
                            <a href="mailto:hello@ednuv.com">belgiumstory&#64;storymediadigital.co
                            </a>
                        </li>
                        <li>
                            <i class='bx bx-envelope'></i>
                            <a href="mailto:hello@ednuv.com">info&#64;storymediadigital.co
                            </a>
                        </li>
                    </ul>
                    <ul class="social-link">
                        <li><a href="https://www.facebook.com/StoryMediaDigital/" class="d-block" target="_blank"><i
                                    class='bx bxl-facebook'></i></a></li>
                        <li><a href="https://www.tiktok.com/@belgiumstory" class="d-block" target="_blank"><i
                                    class='bx bxl-tiktok'></i></a></li>
                        <!-- <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li> -->
                        <li><a href="https://www.instagram.com/storymediadigital" class="d-block" target="_blank"><i
                                    class='bx bxl-instagram'></i></a></li>
                        <li><a href="Wa.me/+32 470 13 77 43" class="d-block" target="_blank"><i
                                    class='bx bxl-whatsapp'></i></a></li>
                        <!-- <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li> -->
                        <!-- <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-pinterest-alt'></i></a></li> -->
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget mb-30">
                    <h3>Menü</h3>
                    <ul class="support-link">
                        <li><a routerLink="our-works">Çalışmalar</a></li>
                        <li><a routerLink="gallery">Galeri</a></li>
                        <!-- <li><a routerLink="blog">Blog</a></li> -->
                        <li><a routerLink="services">Hizmetler</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget mb-30">
                    <h3>Bağlantılar</h3>
                    <ul class="useful-link">
                        <li><a routerLink="about">Hakkımızda</a></li>
                        <!-- <li><a routerLink="team">Ekip</a></li> -->
                        <li><a routerLink="contact">İletişim</a></li>
                    </ul>
                </div>
            </div>
            <!-- <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget mb-30">
                    <h3>Newsletter</h3>
                    <div class="newsletter-box">
                        <p>To get the latest news and latest updates from us.</p>
                        <form class="newsletter-form">
                            <label>Your e-mail address:</label>
                            <input type="email" class="input-newsletter" placeholder="Enter your email" name="EMAIL">
                            <button type="submit">Subscribe</button>
                        </form>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
    <div class="footer-bottom-area">
        <div class="container">
            <!-- <div class="logo">
                <a routerLink="/" class="d-inline-block"><img src="assets/img/logo.png" alt="image"></a>
            </div> -->
            <p>Designed and Developed by ©StoryMediaDigital</p>
        </div>
    </div>
</footer>

<ngx-scrolltop></ngx-scrolltop>